// import { setCredentials, logOut } from '../../features/auth/profileSlice'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { $BASE_URL } from 'constants'
import { logOut } from 'store/authSlice'

const baseQuery = fetchBaseQuery({
    baseUrl: `${$BASE_URL}/api/v1`,
    //  credentials: 'include',
    prepareHeaders: (headers) => { //(headers, { getState })
        const token = localStorage.getItem("token") || null
        if (token) {
            headers.set("Authorization", `Bearer ${token}`)
        }
        const lang = localStorage.getItem("i18nextLng") || "ar-SA"
        headers.set("Accept-Language", lang)
        return headers
    }
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions)
    if (result?.error?.originalStatus === 403) {
        api.dispatch(logOut())
    }
    return result
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: 5,
    endpoints: builder => ({})
})